class FB_FireBox_Analytics {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        document.addEventListener('click', function(e) {
            this.onNavClick(e);
        }.bind(this));
    }

    onNavClick(e) {
        let btn = e.target.closest('.firebox-analytics-block--nav--item');
        if (!btn) {
            return;
        }

        e.preventDefault();

        let item = btn.dataset.tab;

        const wrapper = btn.closest('.firebox-analytics-block');

        // Hide previous tab
        wrapper.querySelector('.firebox-analytics-block--nav--item.is-active').classList.remove('is-active');
        wrapper.querySelector('.firebox-analytics-block--content--item.is-active').classList.remove('is-active');
        
        // Show new tab
        wrapper.querySelector('.firebox-analytics-block--nav--item[data-tab="' + item + '"]').classList.add('is-active');
        wrapper.querySelector('.firebox-analytics-block--content--item[data-tab="' + item + '"]').classList.add('is-active');
    }
}

FP_Utils.onReady(function() {
	new FB_FireBox_Analytics();
});